import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import cx from 'classnames';

import { UserContext } from 'Context/user';

import routing from 'Utilities/routing';

import { routes } from '../../../routes';
import { useAuthUI } from '../experiments/useAuthUI/useAuthUI';

import styles from './Header.scss';

export const HeaderBackground: React.FC = () => {
  const { pathname } = useLocation();
  const { userState } = useContext(UserContext);
  const { isAuthUIJourney } = useAuthUI();

  const route = routing.getMatch(pathname, routes);
  const user = Number.isInteger(userState?.id);

  const isHomePage = ['/', '/mileage'].includes(pathname);
  const isSignInPage = route.vrmPath && isAuthUIJourney && !user;

  const history = useHistory<{ animateFromNewHomePage?: boolean }>();
  const { animateFromNewHomePage } = history?.location?.state ?? {};

  return (
    <>
      <div className={cx(styles.headerBackground, {
        [styles.isTranslucent]: (isHomePage || (isSignInPage && !!animateFromNewHomePage)),
        [styles.animated]: !!animateFromNewHomePage,
      })} />
    </>
  );
};
